import React, { Component } from 'react'
import Page from '../../ScheduleTool/Page'
import { HeaderView } from '@merchant-backend/common-components'

export default class extends Component {
  render() {
    const header = ['团队管理', '团队档期']

    return (
      <HeaderView
        header={header}
        title="团队档期"
        contentStyle={{
          backgroundColor: 'initial',
          paddingLeft: 0,
          paddingRight: 0
        }}
      >
        <Page isTeamSchedule={true} />
      </HeaderView>
    )
  }
}
